var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"paginationWrapper",staticClass:"pagination-wrapper"},[_c('div',{staticClass:"pagination-navigation-wrapper"},[_c('button',{class:['next-page-btn', { centered: true }]},[(_vm.isLoading)?_c('BaseSpinner',{staticClass:"spinner-loader"}):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }